import React from "react";
import PropTypes from "prop-types";
import { svgIconsList } from "./iconsList";
import svgIconSprite from "./svgIcons.sprite.svg";

export const SvgIcons = ({
  name,
  className = "",
  width = "24",
  height = "24",
  ...props
}) => {
  // In embedded mode, the sprite is inlined into the DOM (see index.js).
  // Use local #id refs instead of cross-origin url#id (blocked by browsers).
  const iconHref = window.__SANDBOX_IS_PLUGIN__
    ? `#${name}`
    : `${svgIconSprite}#${name}`;

  return (
    <svg className={className} width={width} height={height} {...props}>
      <use href={iconHref} />
    </svg>
  );
};

SvgIcons.propTypes = {
  name: PropTypes.oneOf(svgIconsList).isRequired,
  styles: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};
